import React, { Component } from "react";
import CardList from "../Components/cardlist";
import SearchBox from "../Components/searchbox";
import "./app.css"
import Scroll from "../Components/scroll"
import ErrBoundary from '../Components/ErrBoundary';



class App extends Component {
    constructor () {
        super()
        this.state = {
            robots : [],
            SearchField: "" 
        }
    }

    searchEvent = (event) => {  
        this.setState({SearchField: event.target.value})
    }
    componentDidMount() {
        fetch("https://jsonplaceholder.typicode.com/users")
        .then(Response => Response.json())
        .then(json => this.setState({robots: json}))
        
    }


    render () {
        const { robots, SearchField } = this.state
        const filteredrobots = robots.filter(robot => {
            return robot.name.toLowerCase().includes(SearchField.toLowerCase())
        })
        return !robots.length ?
             <h1 className="a1">loading...</h1> :
       (
            <div className="tc">
            <h1 className="f1">Robo friends</h1>
            <SearchBox search={this.searchEvent}/>
            <Scroll>
                <ErrBoundary>
            <CardList robots={filteredrobots}/>
                </ErrBoundary>
            </Scroll>
            </div>
        ); }
    }


export default App;